import React from 'react'
import { compose } from 'recompose'
import withIntl from 'store/intl/withIntl'
import CustomTabs from 'components/Tabs/CustomTabs'
import FormLabel from 'components/labels/FormLabel'
import toUpper from 'lodash/toUpper'

const langLabel = {
  en: 'Language',
  th: 'ภาษา',
}

export default () => compose(
  withIntl(),
  (WrappedComponent) => ({
    label,
    noLabel,
    value,
    onChange,
    currentLang,
    availableLanguages,
    switchLanguage,
    createPropsByLang = () => ({}),
    ...props
  }) => (
    <div>
      {!noLabel && (
        <FormLabel>{label || langLabel[currentLang]}</FormLabel>
      )}
      <CustomTabs
        defaultTabValue={currentLang}
        onTouchTab={switchLanguage}
      >
        {availableLanguages.map((lang) => (
          <WrappedComponent
            key={lang}
            {...props}
            {...createPropsByLang(lang)}
            style={{ marginLeft: 10, marginTop: 0 }}
            tabValue={lang}
            tabLabel={toUpper(lang)}
            value={value[lang]}
            onChange={(val) => onChange({ ...value, [lang]: val })}
          />
        ))}
      </CustomTabs>
    </div>
  ),
)



// WEBPACK FOOTER //
// ./src/hocs/bases/withFormLanguages.js